import React from 'react';
import {Tabs, Tab} from 'material-ui/Tabs';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import user from '../Auth/user';
import compose from '../compose';
import InventoryTab from './InventoryTab';
import CustomersTab from './CustomersTab';
import SalesTab from './SalesTab';
import './Dashboard.css';

class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentTab: '0',
      stands: null,
      products: null
    };
  }

  componentWillMount() {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;

    firebase.database()
      .ref(`shopkeepers/${shopkeeperId}/standsList`)
      .orderByChild('name')
      .once('value', (snapshot) => {
        const stands = [];
        snapshot.forEach((data) => {
          stands[data.key] = data.val();
        });
        this.setState({stands});
      });

    firebase.database()
      .ref(`shopkeepers/${shopkeeperId}/products`)
      .orderByChild('name')
      .once('value', (snapshot) => {
        const products = [];
        snapshot.forEach((data) => {
          products[data.key] = data.val();
        });
        this.setState({products});
      });
  }

  handleTabChange = (currentTab) => {
    this.setState({
      currentTab
    });
  };

  render() {
    const boxStyle = {
      boxSizing: 'border-box',
      minWidth: '400px',
      minHeight: '400px',
      display: 'flex',
      flexGrow:'1',
      position: 'relative',
      border:'1px solid #e9e9e9',
      borderRadius: '5px',
      padding: '5px',
      margin: '5px'
    };

    const tabProps = {
      boxStyle,
      stands: this.state.stands,
      products: this.state.products
    };

    const {t} = this.props;

    return (
      <div className='dashboardDiv'>
        <Tabs
          value={this.state.currentTab}
          onChange={this.handleTabChange}
        >
          <Tab label={t('dashboard.salesTab')} value='0'>
            <SalesTab  {...tabProps}/>
          </Tab>
          <Tab label={t('dashboard.customersTab')} value='1'>
            <CustomersTab  {...tabProps}/>
          </Tab>
          <Tab label={t('dashboard.inventoryTab')} value='2'>
            <InventoryTab  {...tabProps}/>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Dashboard);



// WEBPACK FOOTER //
// ./src/Dashboard/Dashboard.js